'use client'

import React from 'react'
import ShareDialog from "@/components/share-dialog";

const TopButtons = () => (
  <div className='flex justify-between w-full max-w-[680px]'>
    <div>
      <ShareDialog link={{name: "LUX", url: "", icon: ""}} showButton={true} />
    </div>
  </div>
)

export default TopButtons
